import styled from "@emotion/styled";
import { AddRounded, DeleteRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
	converAttrToDatagridCol,
	createdByColumns,
	deleteTableColumn,
	imageTableColumn,
	imageTableColumnWithEdit,
	styleImageColumn,
	tableMetadataDatagridRenderCells,
	arrType,
} from "data/globalData";
import {
	attrGroupLinkedTables,
	constraintsOptions,
	isColumnDefault,
	publishTableColumn,
	productionStageOptions,
} from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { useEffect, useMemo, useState } from "react";
import { PimDashboardState } from "context/PimDashboardContext";
import { DataGrid } from "@mui/x-data-grid";
import { constraints, inputTypes, isRejectablePublishedColor, publishColumns, statusOptions } from "data/globalData";
import { AuthState } from "context/AuthContext";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import AddNewModal from "./AddNewModal/AddNewModal";
import EditColorDetails from "./EditColorDetails/EditColorDetails";
import { sourcingOnlyColorColumnKeys, buildColorTableColumns, getDesignerEditableColorColumns } from "components/PimDashboard/DashboardComponents/Sourcing/FabricStylesDashboard/EditFabricStyleDetails/data";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});

const ColorsSection = ({ colorsArr, disableEdit = false }) => {
	const { attrGroupsWithAttr, selectedStyle, setSelectedStyle, allAttributes } = PimDashboardState();
	const { user } = AuthState();
	const [colorTableColumns, setColorTableColumns] = useState();
	const [colors, setColors] = useState(colorsArr ? colorsArr : []);
	const [addModal, setAddModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [rowToUpdate, setRowToUpdate] = useState();
	const [rejectingColorId, setRejectingColorId] = useState(null);
	const [colorToReject, setColorToReject] = useState(null);

	const styleStage = selectedStyle?.[attrGroupLinkedTables.style.key]?.stage;
	const isStyleAttributesStage = styleStage === productionStageOptions.STYLE_ATTRIBUTES.key;

	const publishedColorCount = useMemo(
		() => (Array.isArray(colors) ? colors.filter(isRejectablePublishedColor).length : 0),
		[colors],
	);

	const canRejectColor = (row) =>
		!disableEdit && !isStyleAttributesStage && isRejectablePublishedColor(row) && publishedColorCount > 1;
	useEffect(() => {
		setColorTableColumns(buildColorTableColumns(allAttributes, attrGroupsWithAttr));
	}, [attrGroupsWithAttr, allAttributes]);

	const colorFormColumns = useMemo(
		() => getDesignerEditableColorColumns(colorTableColumns),
		[colorTableColumns],
	);

	useEffect(() => {
		setColors(colorsArr);
	}, [colorsArr]);
	const { setSnackBarOpen, setSnackBar, snackBar, setLoadingOpen } = GlobalState();
	const handleAddModalOpen = () => {
		setAddModal(true);
	};

	const handleColorDelete = (color) => {
		setColors(colors.filter((row) => !(row?.id === color?.id && row.pallete === color.pallete)));
	};
	const handleImageFileUpload = async (newColor) => {
		const formData = new FormData();
		if (!newColor.file) {
			return [{ publicUrl: "" }];
		}
		formData.append("files", newColor.file);

		const res = await axios.post("/api/designer/multiple_image_upload", formData, {
			headers: {
				"content-type": "multipart/form-data",
			},
		});
		return res.data;
	};
	const handleAddColorFun = async (newColor) => {
		let count = [];
		allAttributes?.forEach((row) => {
			if (
				row.linked_table === attrGroupLinkedTables.color.key &&
				!sourcingOnlyColorColumnKeys.includes(row.key) &&
				row?.constraints?.[constraintsOptions.NOTNULL.key] &&
				isColumnDefault(row, newColor?.[row.key])
			)
				count.push(row);
		});
		if (count.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Missing required fields: ${count.map((row) => row.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		const isPresent = colors.reduce((acc, row) => {
			count = 0;
			allAttributes?.forEach((clrCol) => {
				if (
					clrCol.linked_table === attrGroupLinkedTables.color.key &&
					!sourcingOnlyColorColumnKeys.includes(clrCol.key) &&
					newColor[row.key] === row[clrCol.key]
				)
					count++;
			});
			if (count === colorFormColumns?.length) acc.push(row);
			return acc;
		}, []);
		console.log(isPresent, "asdgjfdgfhjk");
		if (isPresent.length > 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Color is already present",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}

		try {
			setLoadingOpen(true);
			const [{ publicUrl }] = await handleImageFileUpload(newColor);

			if (!publicUrl) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: "Please upload color image", severity: "error" });
				setLoadingOpen(false);
				return;
			}
			let obj = {
				...newColor,
				status: statusOptions.DESIGNER_PENDING.key,
				created_by: user.email,
				style_id: selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id,
				url: publicUrl,
				is_published: false,
				rejected: false,
			};
			const res = await axios.post("/api/designer/create_color", obj);
			const styleId = selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id;
			const refreshedStyle = await axios.get(`/api/designer/style_by_id/${styleId}`);
			setSelectedStyle(refreshedStyle.data);
			setColors(refreshedStyle.data?.[attrGroupLinkedTables.color.key] ?? []);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: res?.data?.message || "Color created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return true;
		} catch (err) {
			console.log(err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(err) });
			setLoadingOpen(false);
			return false;
		}
	};
	const handleEditColorFun = async (updatedColor) => {
		let count = [];
		allAttributes?.forEach((row) => {
			if (
				row.linked_table === attrGroupLinkedTables.color.key &&
				!sourcingOnlyColorColumnKeys.includes(row.key) &&
				row?.constraints?.[constraintsOptions.NOTNULL.key] &&
				isColumnDefault(row, updatedColor?.[row.key])
			)
				count.push(row);
		});
		if (count.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Missing required fields: ${count.map((row) => row.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		const isPresent = colors.reduce((acc, row) => {
			count = 0;
			allAttributes?.forEach((clrCol) => {
				if (
					clrCol.linked_table === attrGroupLinkedTables.color.key &&
					!sourcingOnlyColorColumnKeys.includes(clrCol.key) &&
					updatedColor[row.key] === row[clrCol.key]
				)
					count++;
			});
			if (count === colorFormColumns?.length) acc.push(row);
			return acc;
		}, []);
		if (isPresent.length > 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Color is already present",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}

		try {
			setLoadingOpen(true);

			let obj = {
				...updatedColor,
				last_updated_by: user.email,
			};
			await axios.put("/api/designer/update_color", obj).then((res) => {
				if (res.status === 422) {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: res && res.data ? res.data.message : "Something went wrong",
						severity: "warning",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					return false;
				}
				setColors((prev) => {
					return prev.map((color) => {
						if (color.id === updatedColor.id) {
							return {
								...color,
								...updatedColor,
							};
						}
						return color;
					});
				});
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: res.data.message ? res.data.message : "Success",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			});
			return true;
		} catch (err) {
			console.log(err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(err) });
			setLoadingOpen(false);
			return false;
		}
	};
	const handleColorImageUpdate = async (e, row) => {
		e.stopPropagation();
		// e.preventDefault();
		let file = e.target.files?.[0];
		console.log("ghsfkesd", row, file);
		setLoadingOpen(true);
		try {
			const data = new FormData();
			data.append("files", file);
			data.append("colorWithImgUrl", JSON.stringify(row));
			const res = await axios.put("/api/designer/update_color_image", data, {
				headers: { "Content-Type": "multipart/form-data" },
			});
			let updatedColors = colors.map((color) => {
				if (color.id === row.id) {
					return {
						...color,
						url: res.data.url,
					};
				}
				return color;
			});
			setColors(updatedColors);
			setSelectedStyle({
				...selectedStyle,
				[attrGroupLinkedTables.color.key]: updatedColors,
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Image Updated Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			console.log(error);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	const handleColorClick = (color, e) => {
		setRowToUpdate(color);
		setEditModal(true);
	};

	const handleRejectColor = async (colorRow) => {
		if (!canRejectColor(colorRow)) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				severity: "error",
				message: "At least one published color must remain on this style",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}

		try {
			setRejectingColorId(colorRow.id);
			setLoadingOpen(true);
			await axios.put("/api/designer/reject_color_by_designer", {
				style_id: selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id,
				color_id: colorRow.id,
			});
			const updatedColors = colors.map((row) =>
				row.id === colorRow.id ? { ...row, status: statusOptions.REJECTED.key } : row,
			);
			setColors(updatedColors);
			setSelectedStyle((prev) => ({
				...prev,
				[attrGroupLinkedTables.color.key]: updatedColors,
			}));
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "success", message: "Color rejected successfully" });
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		} finally {
			setRejectingColorId(null);
			setColorToReject(null);
			setLoadingOpen(false);
		}
	};

	const handleRejectClick = (colorRow) => {
		if (!canRejectColor(colorRow)) return;
		setColorToReject(colorRow);
	};

	return (
		<Box display="flex" flexWrap="wrap" width="100%" justifyContent="space-around">
			<Box height={320} width="100%">
				<Box display="flex" justifyContent="space-between" width="100%" pt={1} pb={1} alignItems="center">
					<Typography variant="h6" width="100%">
						Colors
					</Typography>
					<Button variant="contained" size="small" onClick={handleAddModalOpen} disabled={disableEdit}>
						Add
					</Button>
				</Box>
				{colorTableColumns?.length >= 0 && (
					<DataGrid
						rows={colors ? colors : []}
						columns={[
							disableEdit
								? imageTableColumn(styleImageColumn)
								: imageTableColumnWithEdit(styleImageColumn, handleColorImageUpdate),
							...colorTableColumns?.map((colorCol) => {
								return {
									field: colorCol?.key,
									headerName: colorCol?.name?.toUpperCase(),
									minWidth: 130,
									headerAlign: "center",
									align: "center",
									flex: 1,
								};
							}),
							...createdByColumns.map((row) => converAttrToDatagridCol(row)),
							publishTableColumn(null, true),
							{
								field: "action",
								headerName: "Action",
								minWidth: 110,
								headerAlign: "center",
								align: "center",
								flex: 1,
								sortable: false,
								filterable: false,
								renderCell: ({ row }) => (
									<Button
										size="small"
										color="error"
										variant="outlined"
										disabled={!canRejectColor(row) || rejectingColorId === row.id}
										onClick={(e) => {
											e.stopPropagation();
											handleRejectClick(row);
										}}>
										Reject
									</Button>
								),
							},
						]}
						sx={{
							minHeight: 290,
							maxHeight: 290,
							// width: "95%",
							"& .MuiDataGrid-row": {
								borderBottom: "1px solid lightgray",
								cursor: "pointer",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								// background: grey[300],
								borderRight: "1px solid lightgray",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={60}
						disableRowSelectionOnClick
						hideFooter
						pagination={false}
						onRowClick={(params, e) => !disableEdit && handleColorClick(params.row, e)}
					/>
				)}
			</Box>

			{/* Add Color */}
			<AddNewModal
				modalOpen={addModal}
				setModalOpen={setAddModal}
				submitFunction={handleAddColorFun}
				selectedStyle={selectedStyle}
				columns={colorFormColumns}
			/>
			{editModal && (
				<EditColorDetails
					modalOpen={editModal}
					setModalOpen={setEditModal}
					submitFunction={handleEditColorFun}
					selectedStyle={selectedStyle}
					columns={colorFormColumns}
					rowToUpdate={rowToUpdate}
				/>
			)}

			<Dialog fullWidth maxWidth="xs" open={Boolean(colorToReject)} onClose={() => setColorToReject(null)}>
				<Box p={2}>
					<Typography variant="h6" gutterBottom>
						Reject color?
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Are you sure you want to reject{" "}
						<strong>
							{colorToReject?.color}
							{colorToReject?.pallete ? ` - ${colorToReject.pallete}` : ""}
						</strong>
						? At least one published color must remain on this style.
					</Typography>
				</Box>
				<DialogActions sx={{ px: 2, pb: 2 }}>
					<Button variant="outlined" onClick={() => setColorToReject(null)}>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="error"
						disabled={rejectingColorId === colorToReject?.id}
						onClick={() => colorToReject && handleRejectColor(colorToReject)}>
						Confirm Reject
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default ColorsSection;
